import { DEFAULT_PAGE, DeviceStatus, DeviceType } from "@app/constants";
import { Device, DeviceResponse, UpdateDeviceRequest } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _DeviceService {
  public getDevices(
    page = DEFAULT_PAGE,
    status?: DeviceStatus,
    type?: DeviceType,
    device_name?: string,
    building_name?: string,
    network_provider?: string,
    phone?: string,
    device_id?: string,
    from_date?: string
  ) {
    return HttpService.get<DeviceResponse>("/devices", {
      queryParams: {
        page,
        status,
        type,
        device_name,
        building_name,
        network_provider,
        phone,
        device_id,
        from_date,
      },
    });
  }

  public updateDevice(id: string, updateBody: UpdateDeviceRequest) {
    return HttpService.patch<Device>(`/devices/${id}`, {
      body: {
        ...updateBody,
      },
    });
  }

  public deleteDevice(id: string) {
    return HttpService.delete<Device>(`/devices/${id}`);
  }

  public getDeviceByID(id: string) {
    return HttpService.get<Device>(`/devices/${id}`);
  }
}

const DeviceService = new _DeviceService();

export default DeviceService;
